/**
 * RequireAuth — route guard: no session → redirect to /login (ODE-P01-T10).
 *
 * Client-side routing guard only; the server-side T08 guard remains the
 * authorization authority for every API call.
 *
 * Traces to: ODE-PRD-REQ-077, ODE-PRD-REQ-090.
 */

import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext.js';

export function RequireAuth({ children }: { readonly children: ReactNode }): JSX.Element {
  const { session } = useAuth();
  if (session === null) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
}